import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

import { Form } from 'react-bootstrap'

/**
 * @param {{
 *    id: string
 *    name: string
 *    defaultValue?: any
 *    className?: string
 *    disabled?: boolean
 *    onChange?: any
 *    value?: any
 * }} props
 * @returns {React.Component}
 */
const ZariInputNumber = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <Form.Control
      {...props}
      ref={ref}
      className={clsx('zr-form__control zr-form__input-number', className)}
      type='number'
      size='sm'
    />
  )
})

ZariInputNumber.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  defaultValue: PropTypes.any,
  value: PropTypes.any,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func
}

ZariInputNumber.displayName = 'ZariInputNumber'

export default ZariInputNumber
